import { CommissionTypes } from 'constants/commissionTypes';
import { EMPTY_FIELD } from 'constants/emptyField';

import { blue } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Typography } from 'shared/mui/Typography';
import { Commission } from 'types/embedded/commission';

type Props = {
  record: Commission;
  onClick: () => void;
};

export const MerchantShowCommissionRelatedCommissionsLink: React.FC<Props> = ({
  record,
  onClick,
}) => {
  const translate = useTypedTranslate();
  const type = record.typeEnum?.value;
  const isShowLink = type === CommissionTypes.Child || type === CommissionTypes.Parent;

  if (!isShowLink) {
    return <>{EMPTY_FIELD}</>;
  }

  return (
    <Typography
      onClick={onClick}
      sx={{
        textDecoration: 'underline',
        cursor: 'pointer',
        color: blue[700],
        fontSize: '14px',
      }}
    >
      {translate('app.buttons.goTo')}
    </Typography>
  );
};
